export default __webpack_public_path__ + "static/media/jobsImage.ef9a7a71.png";